function About(){
  return(
    <section id="about" className="about">

      <h2>About Me</h2>

      <p>
     Full Stack Developer & Automation Tester (Selenium + Python)
    I’m a detail-oriented developer with expertise in building full-stack applications and automating web testing using Selenium and Python. I focus on writing clean, efficient code and ensuring applications are robust, reliable, and user-friendly. Passionate about problem-solving, I’m looking for opportunities to apply my skills in real-world projects and grow as a developer.
      </p>

    </section>
  )
}

export default About